import { faqCollectionBodySchema } from "@redotech/redo-support-common/faq/faq-body-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateCollection = {
  name: "updateCollection" as const,
  input: z.object({
    _id: z.string(),
    title: z.string().optional(),
    description: z.string().optional(),
    published: z.boolean().optional(),
    articles: z.array(zExt.objectId()).optional(),
  }),
  output: z.union([
    z.object({ ok: z.literal(true), value: faqCollectionBodySchema }),
    z.object({ ok: z.literal(false), error: z.string() }),
  ]),
};
